export const faceSwap = {
    // Page title and basic text
    title: 'AI Face Pinch',
    subtitle: 'Intelligent Face Customization Tool',
    description: 'Customize and generate character images through option configuration and image upload',
    
    // Main function tabs
    tabs: {
      textToImage: 'Text to Image',
      imageToImage: 'Image to Image'
    },
    
    // 按鈕文本
    buttons: {
      generate: 'Generate',
      download: 'Download',
      preview: 'Preview',
      upload: 'Upload Image',
      clear: 'Clear',
      save: 'Save',
      cancel: 'Cancel',
      confirm: 'Confirm',
      reset: 'Reset',
      random: 'Random Selection',
      clearAll: 'Clear All',
      backToWorkbench: 'Back to Workbench'
    },
    
    // Status text
    status: {
      generating: 'Generating...',
      uploading: 'Uploading...',
      processing: 'Processing...',
      completed: 'Completed',
      failed: 'Failed',
      ready: 'Ready'
    },
    
    // Message prompts
    messages: {
      uploadSuccess: 'Upload successful',
      uploadFailed: 'Upload failed',
      generateSuccess: 'Generation successful',
      generationSuccess: 'Generation successful',
      generateFailed: 'Generation failed',
      invalidFile: 'Invalid file format',
      fileTooLarge: 'File too large',
      networkError: 'Network error',
      generationStarted: 'Generation started',
      generationStatusError: 'Generation status error',
      generationTimeout: 'Generation timeout',
      queryStatusFailed: 'Query status failed',
      uploadFirst: 'Please upload an image first',
      generateIdError: 'Generate ID error',
      downloadFailed: 'Failed to download image'
    },
    
    // Prompt input
    prompt: {
      label: 'Prompt',
      placeholder: 'Enter description text...',
      help: 'Describe the character features you want in detail'
    },
    
    // Upload area
    upload: {
      title: 'Upload Image',
      dragText: 'Drag image here',
      clickText: 'or click to select file',
      supportedFormats: 'Supports JPG, PNG formats',
      maxSize: 'Max 10MB',
      placeholder: 'Please upload an image'
    },
    
    // 結果展示
    result: {
      title: 'Generated Result',
      original: 'Original',
      generated: 'Generated',
      noResult: 'No result yet',
      placeholder: 'Generated images will be displayed here'
    },

    // 預覽模態框
    preview: {
      title: 'Image Preview',
      imageAlt: 'Preview Image'
    },
    
    // Category definitions
    categories: {
      role: 'Role',
      photography: 'Photography',
      style: 'Style',
      environment: 'Environment'
    },
    
    // Options related
    options: {
      pleaseSelect: 'Please select'
    },
  };
